import { produce } from "immer";
import * as Actions from "pages/Settings/Signs/store/signatureActions";

const initialState = {
  isLoading: false,
  errorMessage: null,
  currentItem: null
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.SAVE_SIGNATURE:
      draft.isLoading = true;
      draft.errorMessage = null;
      break;

    case Actions.SAVE_SIGNATURE_SUCCESS:
      draft.isLoading = false;
      break;

    case Actions.SAVE_SIGNATURE_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.SET_CURRENT_ITEM:
      draft.currentItem = action.payload.item;
      break;

    case Actions.RESET_FAILED:
      draft.errorMessage = null;
      break;

    default:
      break;
  }
}, initialState);

export default reducer;
